/** Admin SPA развёрнута под /admin/ на том же tenant-origin, а не в клиентском роутере. */
export function distributorWorkspacePath(role: string | undefined): string | null {
  if (role === 'DISTRIBUTOR_OWNER') return '/admin/'
  if (role === 'DISTRIBUTOR_EMPLOYEE') return '/admin/manager-payers'
  return null
}
